import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import logo from '../assets/logopng3.png';
import seloLGPD from '../assets/selo_lgpd.webp';
import seloResponsabilidade from '../assets/Selo_Responsabilidade_Civil.webp';
import TermosModal from '../components/TermosModal';
import '../styles/login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [modoCliente, setModoCliente] = useState(false);
  const [mostrarTermos, setMostrarTermos] = useState(false);
  const [loadingTermos, setLoadingTermos] = useState(false);
  const [tokenTemporario, setTokenTemporario] = useState(null);
  const navigate = useNavigate();

  const decodeJwt = (token) => {
    try {
      return jwtDecode(token);
    } catch (e) {
      console.error("Erro ao decodificar JWT:", e);
      return null;
    }
  };

  const registerLogin = async (accessToken) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/register-login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (!response.ok) {
        console.warn('Falha ao registrar login no sistema');
      }
    } catch (error) {
      console.error('Erro ao registrar login:', error);
    }
  };

  const buscarDadosUsuario = async (accessToken) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data;
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
      return null;
    }
  };

  const verificarTermos = async (accessToken) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/verificar-termos/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.precisa_aceitar;
      }
      return false;
    } catch (error) {
      console.error('Erro ao verificar termos:', error);
      return false;
    }
  };

  const redirecionarPorIdBpo = async (id_bpo) => {
    if (id_bpo === 0 || id_bpo === null) {
      // voltou de um link (e-mail, favorito) sem estar logado: vai para onde ia
      let destino = null;
      try {
        destino = sessionStorage.getItem('saber_voltar_para');
        sessionStorage.removeItem('saber_voltar_para');
      } catch (e) { destino = null; }
      navigate(destino && destino.startsWith('/') && !destino.startsWith('//') ? destino : '/home');
    } else if (id_bpo === 19) {
      navigate(`/Posicao_dia/${id_bpo}`);
    } else if (id_bpo > 0) {
      // A rota do dashboard depende do SISTEMA do cliente (Omie × Conta Azul) —
      // cliente CA na página Omie carrega os cards mas quebra os gráficos.
      let rota = `/dashboard-cliente/${id_bpo}`;
      try {
        const resp = await fetch(`${process.env.REACT_APP_API_BASE}/api/cliente-bpo/${id_bpo}/`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('access')}` },
        });
        if (resp.ok) {
          const d = await resp.json();
          if ((d.cliente?.sistema || '').toLowerCase() === 'conta_azul') {
            rota = `/dashboard-conta-azul/${id_bpo}`;
          }
        }
      } catch (e) { /* sem resposta → mantém a rota padrão */ }
      navigate(rota);
    } else {
      setErro('Usuário sem permissões configuradas. Contate o administrador.');
      localStorage.clear();
      return;
    }

    window.location.reload();
  };

  const aceitarTermos = async () => {
    setLoadingTermos(true);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/aceitar-termos/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${tokenTemporario}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setMostrarTermos(false);
        
        const dadosUsuario = await buscarDadosUsuario(tokenTemporario);
        
        if (dadosUsuario && dadosUsuario.success) {
          const id_bpo = dadosUsuario.id_bpo;
          
          localStorage.setItem('userName', dadosUsuario.name || dadosUsuario.first_name || '');
          localStorage.setItem('id_bpo', id_bpo);
          localStorage.setItem('isCliente', id_bpo > 0 ? 'true' : 'false');
          
          await registerLogin(tokenTemporario);
          
          redirecionarPorIdBpo(id_bpo);
        }
      } else {
        setErro('Erro ao aceitar os termos. Tente novamente.');
        setLoadingTermos(false);
      }
    } catch (error) {
      console.error('Erro ao aceitar termos:', error);
      setErro('Erro ao processar aceite dos termos.');
      setLoadingTermos(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('access', data.access);
        localStorage.setItem('refresh', data.refresh);

        const decoded = decodeJwt(data.access);
        if (decoded && decoded.first_name) {
          localStorage.setItem('firstName', decoded.first_name);
        }

        const dadosUsuario = await buscarDadosUsuario(data.access);
        
        if (dadosUsuario && dadosUsuario.success) {
          const id_bpo = dadosUsuario.id_bpo;
          
          // VALIDAÇÃO: id_bpo deve existir
          if (id_bpo === null || id_bpo === undefined) {
            setErro('Usuário sem permissões. Contate o administrador.');
            localStorage.clear();
            setLoading(false);
            return;
          }
          
          localStorage.setItem('userName', dadosUsuario.name || dadosUsuario.first_name || '');
          localStorage.setItem('id_bpo', id_bpo);
          localStorage.setItem('isCliente', id_bpo > 0 ? 'true' : 'false');
          
          // VALIDAÇÃO: Modo Cliente vs Interno
          if (modoCliente && id_bpo === 0) {
            setErro('Este usuário é um colaborador interno. Use o login normal.');
            localStorage.clear();
            setLoading(false);
            return;
          }
          
          if (!modoCliente && id_bpo > 0) {
            setErro('Você é um cliente. Por favor, use o botão "Sou Cliente".');
            localStorage.clear();
            setLoading(false);
            return;
          }
          
          // VERIFICAR TERMOS (APENAS CLIENTES)
          if (id_bpo > 0) {
            const precisaAceitarTermos = await verificarTermos(data.access);
            
            if (precisaAceitarTermos) {
              console.log('Cliente precisa aceitar os termos');
              setTokenTemporario(data.access);
              setMostrarTermos(true);
              setLoading(false);
              return;
            }
          }
          
          await registerLogin(data.access);
          
          redirecionarPorIdBpo(id_bpo);
        } else {
          setErro('Erro ao carregar dados do usuário.');
          localStorage.clear();
        }
      } else if (res.status === 403) {
        setErro('Acesso bloqueado após 3 tentativas incorretas. Contate o administrador para desbloquear.');
      } else {
        setErro('Usuário ou senha inválidos');
      }
    } catch (err) {
      console.error("Erro ao fazer login:", err);
      setErro('Erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const whatsappUrl = `https://wa.me/555180197979?text=${encodeURIComponent('Olá! Gostaria de solicitar acesso ao sistema.')}`;

  return (
    <div className="login-container">
    <div className="card login-card p-4 shadow">
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" className="login-logo" />
        <p className="header-text2">
          {/* Decolamos ideias, pessoas e projetos inovadores */}
        </p>
      </div>
      
      <div className="d-flex justify-content-center mb-3">
        <div className="btn-group" role="group">
          <button
            type="button"
            className={`btn ${!modoCliente ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => {
              setModoCliente(false);
              setErro('');
            }}
          >
            <i className="fas fa-building me-2"></i>
            Colaborador
          </button>
          <button
            type="button"
            className="btn"
            style={{
              backgroundColor: modoCliente ? '#9063CD' : 'transparent',
              borderColor: '#9063CD',
              color: modoCliente ? '#fff' : '#9063CD'
            }}
            onClick={() => {
              setModoCliente(true);
              setErro('');
            }}
          >
            <i className="fas fa-user-tie me-2"></i>
            Sou Cliente
          </button>
        </div>
      </div>

      <h5 className="text-center mb-3">
        {modoCliente ? (
          <span style={{ color: '#9063CD' }}>
            <i className="fas fa-briefcase me-2"></i>
            Acesso do Cliente
          </span>
        ) : (
          'Acesse sua conta'
        )}
      </h5>

      {erro && <div className="alert alert-danger">{erro}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="login-usuario">{modoCliente ? 'Usuário do Cliente' : 'Usuário'}</label>
          <input
            id="login-usuario"
            type="text"
            className="form-control"
            placeholder={modoCliente ? "Digite o usuário da empresa" : "Digite seu usuário"}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            autoComplete="username"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="login-senha">Senha</label>
          <input
            id="login-senha"
            type="password"
            className="form-control"
            placeholder="Digite sua senha"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoComplete="current-password"
          />
        </div>

        <button 
          type="submit" 
          className="btn w-100"
          style={{
            backgroundColor: modoCliente ? '#9063CD' : '#00205b',
            borderColor: modoCliente ? '#9063CD' : '#00205b',
            color: '#fff'
          }}
          disabled={loading}
        >
          {loading ? (
            <span>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Entrando...
            </span>
          ) : (
            <>
              <i className={`fas ${modoCliente ? 'fa-sign-in-alt' : 'fa-unlock'} me-2`}></i>
              {modoCliente ? 'Entrar como Cliente' : 'Entrar'}
            </>
          )}
        </button>

        <div className="text-end mb-4" style={{ fontSize: '0.85rem', color: '#888', marginTop: '10px' }}>
          V1.7.32
        </div>
      </form>

      {modoCliente && (
        <div className="text-center mt-3 mb-0">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#9063CD',
              cursor: 'pointer',
              fontSize: '0.9rem',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
          >
            <i className="fab fa-whatsapp me-1"></i>
            Ainda não tem acesso? <strong>Clique aqui</strong>
          </a>
        </div>
      )}
    </div>

    {/* <div className="selos-lgpd">
      <img 
        src={seloLGPD} 
        alt="Selo LGPD - Empresa Certificada" 
        className="selo-img selo-lgpd"
      />
      <img 
        src={seloResponsabilidade} 
        alt="Selo Responsabilidade Civil" 
        className="selo-img selo-responsabilidade"
      />
    </div> */}

    <TermosModal 
      show={mostrarTermos}
      onAccept={aceitarTermos}
      loading={loadingTermos}
    />
  </div>
);
};
export default Login;